import { render, staticRenderFns } from "./SingleImage2.vue?vue&type=template&id=2bb1258d&scoped=true"
import script from "./SingleImage2.vue?vue&type=script&lang=js"
export * from "./SingleImage2.vue?vue&type=script&lang=js"
import style0 from "./SingleImage2.vue?vue&type=style&index=0&id=2bb1258d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb1258d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/hbgw-vue_2It6/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bb1258d')) {
      api.createRecord('2bb1258d', component.options)
    } else {
      api.reload('2bb1258d', component.options)
    }
    module.hot.accept("./SingleImage2.vue?vue&type=template&id=2bb1258d&scoped=true", function () {
      api.rerender('2bb1258d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Upload/SingleImage2.vue"
export default component.exports